<template>
  <div>
    <finance-drawer
      title="付款单详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="paymentNo"
      :modal-close="false"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation" v-if="$has('YSKGL-FKGL-FQFKZCFK') && detailInfo.status === 1">
        <btns-operate
          :current="detailInfo"
          :type="detailInfo.type"
          @success="handleOperateStateResults"
        />
      </div>
      <div v-loading="loading">
        <div class="main-cont">
          <div class="main-cont-item">
            <h2 class="title-text">
              基本信息
              <icon-status
                :color="_setStatusColor(detailInfo.status, 'paymentStatus')"
                :status="detailInfo.statusDesc"
              />
            </h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="firstCol" :data="detailInfo">
                <template #payReason>
                  <jr-tooltip :content="detailInfo.payReason || '-'" />
                </template>
                <template #orderNumber>
                  <jr-tooltip :content="detailInfo.orderNumber" type="popover" />
                </template>
              </jr-col>
              <jr-col :data-show="secondCol" :data="detailInfo">
                <template #bankCardNumber>
                  <template v-if="detailInfo.payMode === 'ALIPAY' && detailInfo.payWay === 32">
                    <jr-preview-image :image-list="$stringToArray(detailInfo.qrCodeUrl)|| []" :is-link="true" />
                  </template>
                  <span v-else>
                    <page-encrypt-icon
                      :value.sync="detailInfo[`bankCardNumber-new`]"
                      :encryptValue="detailInfo.bankCardNumber"
                    />
                  </span>
                </template>
              </jr-col>
              <jr-col :data-show="thirdCol" :data="detailInfo" />
            </el-row>
          </div>
          <trading-card :data="detailInfo" title="付款账户信息" />
          <div class="main-cont-item">
            <h2 class="title-text">付款凭证</h2>
            <div>
              <div v-if="!detailInfo.certificate" class="no-certificate">无凭证</div>
              <jr-preview-image v-else :image-list="$stringToArray(detailInfo.certificate)|| []" :is-own="true" />
            </div>
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">关联的采购商收款单</h2>
            <jr-table
              size="mini"
              :tableData="(receiptList || [])"
              :tableColumn="receiptTableColumn"
              :pagination="true"
              :total="receiptTableTotal"
              :search-params.sync="receiptParams"
              :loading="receiptListLoading"
              @refresh="refreshList"
            />
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">关联的付款渠道流水</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.payList || [])"
              :tableColumn="payTableColumn"
            />
          </div>
        </div>
      </div>
    </finance-drawer>
  </div>
</template>
<script>
import { getPaymentPaymentDetail } from '@/api/receivables';
import { setStatusColor } from '@/filters/index';
import btnsOperate from './btns-operate';
import tradingCard from './trading-card';
import { getOrderReceiptInfos } from '@/api/receivables/receipt';

export default {
  props: {
    paymentNo: {
      type: String,
      default: '',
    },
    sourceType: {
      type: Number,
      default: 1,
    },
    queryForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    btnsOperate,
    tradingCard,
  },
  data() {
    return {
      detailInfo: {},
      loading: false,
      payableNo: '', // 应收单编号
      firstCol: [
        { label: '客户名称:', prop: 'businessName' },
        { label: '客户编号:', prop: 'businessNo' },
        { label: '付款类型:', prop: 'typeDesc' },
        { label: '业务订单号:', prop: 'orderNumber', slotName: 'orderNumber' },
        { label: '付款单状态:', prop: 'statusDesc' },
        { label: '付款时间:', prop: 'payTime', filters: 'formatTime' },
        { label: '付款原因:', prop: 'payReason', slotName: 'payReason' },
        { label: '服务商名称:', prop: 'payeeBusinessName' },
      ],
      secondCol: [
        { label: '付款金额:', prop: 'payAmount', filters: 'toFenThousandsAndFloat', className: 'detail-amount_num' },
        { label: '付款方式:', prop: 'payModeDesc' },
        { label: '收款户名:', prop: 'bankAccountName' },
        { label: '收款账户:', prop: 'bankCardNumber', slotName: 'bankCardNumber' },
        { label: '收款银行:', prop: 'bankName' },
        { label: '支行名称:', prop: 'bankBranchInfo' },
        { label: '账户类型:', prop: 'bankAccountTypeDesc' },
      ],
      thirdCol: [
        { label: '归属业务:', prop: 'sourceDesc' },
        { label: '业务类型:', prop: 'busiTypeDesc' },
        { label: '创建人:', prop: 'cruser' },
        { label: '创建时间:', prop: 'crtime', filters: 'formatTime' },
        { label: '付款申请人:', prop: 'payApplyUser' },
        { label: '付款人:', prop: 'operatorName' },
      ],
      accountCol: [
        { label: '付款账户:', prop: 'payAccount', slotName: 'payAccount' },
        { label: '付款户名:', prop: 'payAccountName' },
        { label: '账户类型:', prop: 'payBankAccountTypeDesc' },
        { label: '银行名称:', prop: 'payBankName' },
        { label: '支行名称:', prop: 'payBankBranchInfo' },
      ],
      // 关联的应付单
      receiptParams: {
        page: 1,
        limit: 10,
      },
      receiptList: [],
      receiptTableTotal: 0,
      receiptListLoading: false,
    };
  },
  computed: {
    // 关联的采购商收款单
    receiptTableColumn() {
      const list = [
        { label: '收款单编号', prop: 'receiptNo' },
        { label: '收款类型', prop: 'typeDesc' },
        { label: '收款方式', prop: 'receiptTypeDesc' },
        {
          label: '收款单金额(元)',
          prop: 'receiptAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '本次收款金额(元)',
          prop: 'amount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '创建时间',
          prop: 'crtime',
          filterName: 'formatTime',
        }, {
          label: '状态',
          status: 'verifiedStatus',
          statusDesc: 'verifiedStatusDesc',
          statusColor: (val) => this._setStatusColor(val, 'receiptStatus'),
        },
      ];
      return list;
    },
    // 渠道流水表格
    payTableColumn() {
      const list = [
        {
          label: '上游渠道流水',
          prop: 'thirdNo',
        }, {
          label: '付款方式',
          prop: 'payModeDesc',
        }, {
          label: '付款渠道',
          prop: 'payWayDesc',
        }, {
          label: '付款金额',
          prop: 'payAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '创建时间',
          prop: 'payTime',
          filterName: 'formatTime',
        },
        // 状态：1 待付款 2、付款中 3、部分付款 4、已付款 -1、付款失败
        {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => this._setStatusColor(val, 'paymentStatus'),
        }, {
          label: '备注',
          prop: 'remark',
        },
      ];
      return list;
    },
  },
  watch: {
    paymentNo: {
      deep: true,
      handler() {
        if (this.paymentNo) {
          this.handleOpen();
        } else {
          this.$message.warning('付款单编号不能为空！！');
        }
      },
      immediate: true,
    },
  },
  methods: {
    async init() {
      await this.getPaymentPaymentDetail();
      this._getReceiptList();
    },
    _setStatusColor(val, type) {
      return setStatusColor(val, type);
    },
    // 付款单操作返回结果
    handleOperateStateResults() {
      this.init();
      this.$emit('operate-success');
    },
    // 打开窗口前
    handleOpen() {
      this.receiptListLoading = false;
      this.receiptTableTotal = 0;
      this.receiptList = [];
      this.detailInfo = {};
      this.$nextTick(() => {
        this.init();
      });
    },
    // 获取详情接口
    async getPaymentPaymentDetail() {
      try {
        this.detailInfo = {};
        this.loading = true;
        const res = await getPaymentPaymentDetail({ paymentNo: this.paymentNo });
        this.detailInfo = res.data || {};
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async _getReceiptList() {
      const { orderNumber } = this.detailInfo;
      if (!orderNumber) return;
      try {
        const res = await getOrderReceiptInfos({
          ...this.receiptParams,
          types: ['1', '5'],
          orderNumbers: orderNumber.split(','),
        });
        this.receiptTableTotal = res.totalCount ?? 0;
        this.receiptList = res.data || [];
      } catch (error) {
        this.receiptListLoading = false;
        this.receiptTableTotal = 0;
        this.receiptList = [];
        console.log(error);
      }
    },
    // 刷新列表
    refreshList(params) {
      this.receiptParams = { ...this.receiptParams, ...params };
      this._getReceiptList();
    },
  },
};
</script>
<style scoped lang="scss">
.no-certificate {
  font-size: 20px;
  color: #909399;
  text-align: center;
  width: 148px;
  height: 148px;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 0 8px 8px 0;
  line-height: 148px;
}
.table-button {
  margin-bottom: 0;
}
</style>

